import Swiper from 'swiper/bundle';

(function($) {
    if (jQuery('.hero__slider').length) {
        const swiper = new Swiper(".hero__slider", {
            loop: true,
            effect: "fade",
            autoplay: {
                delay: 10000,
                disableOnInteraction: false,
            },
        });
    }
})(jQuery);